import { createSelector } from "@ngrx/store";
import { integrationsFeature } from "./integrations.reducer";
import { WORKROADS_INTEGRATION } from "src/app/core/interfaces/integration-detail.interface";


const { selectIsLoadingList, selectIntegrations, selectIntegrationDrafts, selectHealthStatuses } = integrationsFeature;




export const fromIntegrations = {
    selectIsLoadingList,
    selectIntegrationDrafts,
    selectIntegrations,
    selectHealthStatuses
};